import { Button, Form, Input, message, Image } from "antd";
import React, { useState } from "react";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
import "./AuthenticatorQrForm.scss";

export function AuthenticatorQrForm(): JSX.Element {
  const [authenticatorQr, setAuthenticatorQr] = useState("");
  const [authenticatorQrForm] = Form.useForm();
  const [authenticatorCode, setAuthenticatorCode] = useState("");
  const [hideQr, setHideQr] = useState(false);
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const onFinish = () => {
    authSVC
      .setAuthenticatorCode({ authCode: authenticatorCode })
      .then((res: any) => {
        if (res.data.success === true) {
          message.success(res.data.message);
          localStorage.setItem("authenticatorEnable", "true");
          localStorage.setItem("showAuthenticatorQR", "false");
          setTimeout(() => { navigate(-1); }, 1500);
        } else {
          message.error(res.data.error);
        }
      })
      .catch((err) => {
        console.log(`Error : ${err.message}`);
        message.error(err.message);
      });
  };

  const handleCancel = () => {
    setShowConfirm(false);
    console.log(`Cancelled`);
  };

  const enableDisable2FA = () => {
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    console.log(`Selected to enable`);
    authSVC
      .getAuthenticatorQr()
      .then((resp: any) => {
        if (resp.data.qrcode_url) {
          setAuthenticatorQr(resp.data.qrcode_url);
          setHideQr(true);
          console.log(resp.data.qrcode_url);
        }
      })
      .catch((err) => {
        console.log(`Error : ${err.message}`);
        message.error(err.message);
      });
  };

  return (
    <>
      <Form
        form={authenticatorQrForm}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
        className="qr-form"
      >
        {/* ── Step 1: Setup trigger ──────────────────────── */}
        {!hideQr && (
          <Form.Item>
            <button
              type="button"
              className="qr-form__setup-btn"
              onClick={enableDisable2FA}
            >
              <span>🔐</span>
              Setup now!
            </button>
          </Form.Item>
        )}

        {/* ── Step 2: QR + code entry ────────────────────── */}
        {hideQr && (
          <>
            {/* Step indicator */}
            <div className="qr-form__steps">
              <div className="qr-form__step qr-form__step--done">
                <span className="qr-form__step-num">✓</span>
                <span>Scan QR</span>
              </div>
              <div className="qr-form__step-line" />
              <div className="qr-form__step qr-form__step--active">
                <span className="qr-form__step-num">2</span>
                <span>Enter Code</span>
              </div>
            </div>

            {/* Instruction */}
            <p className="qr-form__instruction">
              Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)
            </p>

            {/* QR code */}
            <div className="qr-form__qr-wrap">
              <div className="qr-form__qr-frame">
                <Image
                  src={authenticatorQr}
                  alt="Authenticator QR Code"
                  width={200}
                  height={200}
                  preview={false}
                />
              </div>
              <p className="qr-form__qr-hint">Point your camera at the QR code above</p>
            </div>

            {/* Code input */}
            <div className="qr-form__code-section">
              <p className="qr-form__code-label">
                Enter the 6-digit code from your app
              </p>
              <Form.Item
                name="authCode"
                rules={[{ required: false, message: "" }]}
              >
                <Input
                  className="qr-form__code-input"
                  placeholder="e.g. 123 456"
                  maxLength={6}
                  onKeyUp={(e) =>
                    setAuthenticatorCode((e.target as HTMLInputElement).value)
                  }
                />
              </Form.Item>
            </div>

            {/* Verify button */}
            <Form.Item>
              <button
                type="submit"
                className="qr-form__verify-btn"
              >
               
                Verify & Activate
              </button>
            </Form.Item>
          </>
        )}
      </Form>

      {/* ── Confirm enable dialog ──────────────────────────── */}
      {showConfirm && (
        <div className="qr-backdrop" onClick={handleCancel}>
          <div className="qr-dialog" onClick={(e) => e.stopPropagation()}>

            <div className="qr-dialog__icon-wrap">
              <span>🔐</span>
            </div>

            <h3 className="qr-dialog__title">Enable 2FA?</h3>
            <p className="qr-dialog__desc">
              You'll scan a QR code with your authenticator app to complete setup.
              This adds a strong layer of security to your account.
            </p>

            <div className="qr-dialog__actions">
              <button
                className="qr-dialog__btn qr-dialog__btn--confirm"
                onClick={handleConfirm}
              >
                Yes, Enable
              </button>
              <button
                className="qr-dialog__btn qr-dialog__btn--cancel"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}